import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Check } from 'lucide-react';

export const CustomDropdown = ({ label, value, options, onChange, className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      {label && (
        <label className="block text-sm text-slate-600 mb-2 font-medium">
          {label}
        </label>
      )}
      
      {/* Dropdown Button */}
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-4 py-3 border-2 border-slate-300 rounded-lg bg-white text-left text-lg font-semibold cursor-pointer hover:border-emerald-500 focus:border-emerald-500 focus:outline-none transition-colors flex items-center justify-between"
        style={{ minHeight: '52px' }}
      >
        <span className="text-slate-900">{value}</span>
        <ChevronDown 
          size={20} 
          className={`text-slate-600 transition-transform ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>

      {/* Dropdown Options */}
      {isOpen && (
        <div 
          className="absolute z-50 w-full mt-2 bg-white border-2 border-emerald-500 rounded-lg shadow-2xl max-h-80 overflow-y-auto"
          style={{ 
            boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
          }}
        >
          {options.map((option) => (
            <div
              key={String(option)}
              onClick={() => handleSelect(option)}
              className={`px-4 py-3 cursor-pointer hover:bg-emerald-50 transition-colors flex items-center justify-between ${
                value === option ? 'bg-emerald-100 font-bold text-emerald-700' : 'text-slate-900'
              }`}
            >
              <span className="text-base">{option}</span>
              {value === option && <Check size={18} className="text-emerald-700" />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
